export const FISCAL_DOCUMENT_TYPE = {
  NFSE: "NFSE",
  NFCE: "NFCE",
} as const;

export type FiscalDocumentType =
  (typeof FISCAL_DOCUMENT_TYPE)[keyof typeof FISCAL_DOCUMENT_TYPE];

export interface FiscalExportParams {
  startDate: string;
  endDate: string;
  types: FiscalDocumentType[];
}

export interface FiscalExportResult {
  blob: Blob;
  filename: string;
  nfseCount: number;
  nfceCount: number;
  skippedCount: number;
}
